import axios from 'axios'
import uuid from 'uuid/v4'

const S3UploadPlugin = {
  install(Vue) {
    Object.defineProperties(Vue.prototype, {
      $s3Upload: {
        get() {
          return async function s3Upload(file, key = uuid()) {
            const ext = file.name.split('.').pop()
            const params = {
              key: `${key}.${ext}`,
              type: file.type
            }
            const response = await this.$axios.get('/s3/get-signed-url', { params })
            const { signedUrl, finalUrl } = response.data.data

            await axios.put(signedUrl, file, { headers: {
              'Content-Type': file.type,
              'Cache-Control': 'max-age=31536000'
            } })
            return finalUrl
          }
        }
      }
    })
  }
}

export default S3UploadPlugin
